export default __webpack_public_path__ + "static/media/item_6@2x.76b7257a.webp";